import { Component } from '@angular/core';
import { AuthService } from './auth/services/auth.service';
import { AuthGuardService } from './auth/services/auth-guard.service';
import { ReportService } from './report/services/report.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  loggedIn = false;
  isRouting = false;
  constructor(
    private authService: AuthService,
    private reportService: ReportService,
    private authGuardService: AuthGuardService
  ) {
    this.authService.onLoggedIn.subscribe(loggedIn => {
      if (loggedIn) {
        this.loggedIn = loggedIn;
      }
    });

    this.authGuardService.onRouting.subscribe(
      (isRouting) => this.isRouting = isRouting,
      (error) => console.log(error)
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts